import { defineMessages } from 'react-intl';

export default defineMessages({
    myProfile: {
        "id": "portal.MyProfileCtrl.My Profile",
        "defaultMessage": "My Profile"
    } ,
    accountAccess: {
        "id": "portal.MyProfileCtrl.Account Access",
        "defaultMessage": "Account Access" 
    },
    role: {
        "id": "portal.MyProfileCtrl.Role",
        "defaultMessage": "Role"
    },
    authorityDescription: {
        "id": "portal.MyProfileCtrl.Authority Description",
        "defaultMessage": "Authority Description"
    },
    access: {
        "id": "portal.MyProfileCtrl.Access",
        "defaultMessage": "Access"
    },
    locationsEnabled: {
        "id": "portal.myProfileCtrl.Locations Enabled.",
        "defaultMessage": "Locations Enabled."
    },
    electronicNotification: {
        "id": "portal.MyProfileCtrl.Electronic Notification Enrollment",
        "defaultMessage": "Electronic Notification Enrollment"
    },
    description: {
        "id": "portal.MyProfileCtrl.Description",
        "defaultMessage": "Description"
    },
    enrolled: {
        "id": "portal.MyProfileCtrl.Enrolled",
        "defaultMessage": "Enrolled"
    },
    action: {
        "id": "portal.MyProfileCtrl.Action",
        "defaultMessage": "Action"
    },
    accessNote: {
        "id": "portal.myProfileCtrl.To request a change to your access, please contact your administrator.",
        "defaultMessage": "To request a change to your access, please contact your administrator."
    }
    
});
